var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4877EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1376_95256)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3641 11.9295C18.3641 11.9693 18.3525 12.0083 18.3306 12.0416C18.3088 12.0749 18.2776 12.1011 18.2411 12.117L5.98862 17.4264C5.9492 17.4435 5.90538 17.4477 5.86342 17.4385C5.82145 17.4292 5.78347 17.407 5.75488 17.3749C5.72629 17.3428 5.70855 17.3025 5.70418 17.2598C5.69982 17.217 5.70905 17.174 5.73056 17.1368L8.13817 12.9628C8.16135 12.9226 8.1975 12.8916 8.24068 12.8746L10.6565 11.9295L8.2407 10.9845C8.19752 10.9675 8.16137 10.9365 8.13819 10.8963L5.73056 6.72221C5.70905 6.68501 5.69982 6.64198 5.70418 6.59923C5.70855 6.55648 5.72629 6.5162 5.75488 6.48412C5.78347 6.45204 5.82145 6.42979 5.86342 6.42055C5.90538 6.41131 5.9492 6.41554 5.98862 6.43265L18.2411 11.742C18.2776 11.7579 18.3088 11.7841 18.3306 11.8174C18.3525 11.8507 18.3641 11.8897 18.3641 11.9295Z",
    fill: "#EFEFEF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1376_95256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0693,
    height: 13.0693,
    fill: "white",
    transform: "translate(5.46582 5.46533)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsend);
export default __webpack_public_path__ + "static/media/iconsend.dc1ddbfdc53d0e0ccb7df53e5d3839ec.svg";
export { ForwardRef as ReactComponent };